import React from 'react';
export function Footer() {
  return <footer className="bg-[#3d2a5f] py-12 px-5 sm:px-6 border-t border-[#4d3a6f] text-center" data-id="element-196">
      <div className="container mx-auto max-w-3xl" data-id="element-197">
        <h3 className="text-[#c9a14d] font-serif font-bold text-xl md:text-2xl mb-2 tracking-widest" data-id="element-198">
          🪷 ACADEMIA HOLÍSTICA ARGENTINA™
        </h3>
        <p className="text-white/80 text-sm md:text-base mb-8" data-id="element-199">
          El sistema de formación en Reiki N°1 para Argentina. Porque tu camino
          espiritual no debería postergarse por falta de una formación a la
          altura.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-white/60 text-sm mb-10" data-id="element-200">
          <span className="flex items-center gap-2" data-id="element-201">
            📧 academiaholisticaargentina@gmail.com
          </span>
          <span className="flex items-center gap-2" data-id="element-202">
            📲 Instagram: @academiaholisticaargentina
          </span>
          <span className="flex items-center gap-2" data-id="element-203">
            📘 Facebook: Academia Holística Argentina
          </span>
        </div>

        <div className="text-white/40 text-xs space-y-4" data-id="element-204">
          <p data-id="element-205">
            © Academia Holística Argentina™ 2026 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-206">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-white/80 font-serif italic text-lg mt-6" data-id="element-207">
            🪷 "El momento que siempre esperaste ya llegó."
          </p>
        </div>
      </div>
    </footer>;
}